import(/* webpackMode: "eager" */ "/home/ubuntu/download/69695302c9f2cb0014de4538/golfconnect/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/ubuntu/download/69695302c9f2cb0014de4538/golfconnect/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69695302c9f2cb0014de4538/golfconnect/src/styles/index.css");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69695302c9f2cb0014de4538/golfconnect/src/styles/tailwind.css");
